import { render, staticRenderFns } from "./choose-category.vue?vue&type=template&id=736e7605&"
import script from "./choose-category.vue?vue&type=script&lang=js&"
export * from "./choose-category.vue?vue&type=script&lang=js&"
import style0 from "./choose-category.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports